import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import arrow_left from '/icons/arrow-left.svg';
import arrow_left_white from '/icons/arrow-left-white.svg';

const BackMobileButton = ({ onClick, customText = 'Back to previous step', className = '' }) => {
  const colorMode = useSelector((state) => state.ui.colorMode);

  return (
    <div className={`back-btn flex items-center gap-3 cursor-pointer my-3 justify-center color-swap ${className}`} onClick={onClick}>
      {colorMode === 'light' ?
        <img src={arrow_left} alt="" />
        :
        <img src={arrow_left_white} alt="" />
      }
      {customText}
    </div>
  );
};

BackMobileButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  customText: PropTypes.string,
  className: PropTypes.string
};

export default BackMobileButton;
